<template>
  <div class="app-shell">
    <router-view :key="$route.path" />
    <back-to-top v-if="$route.name !== 'login'" :with-tabs="showTabs" />
    <nav v-if="showTabs" class="tabbar" aria-label="主导航">
      <div class="tabbar-inner">
        <router-link v-for="item in tabs" :key="item.path" :to="item.path === '/schedule' && $route.name === 'schedule' ? $route.fullPath : item.path" :class="{ active: $route.path === item.path }">
          <app-icon :name="item.icon" />
          <span>{{ item.title }}</span>
          <span v-if="item.path === '/workbench' && remind" class="nav-badge">{{ remind > 99 ? '99+' : remind }}</span>
        </router-link>
      </div>
    </nav>
  </div>
</template>
<script>
import { employee, clearSession } from '../common/session'
import BackToTop from '../components/back-to-top'
export default {
  components: { BackToTop },
  data() {
    return {
      tabs: [
        { path: '/workbench', title: '今日', icon: 'today' },
        { path: '/customer', title: '客户', icon: 'users' },
        { path: '/schedule', title: '日程', icon: 'calendar' },
        { path: '/employee', title: '我的', icon: 'user' }
      ]
    }
  },
  computed: {
    showTabs() {
      return ['/workbench', '/customer', '/schedule', '/employee'].indexOf(this.$route.path) >= 0
    },
    remind() {
      return this.$store.state.employee.state.remind
    }
  },
  watch: { '$route.name': 'refresh', '$store.state.revision': 'refresh', '$store.state.customerRevision': 'refresh' },
  created() {
    window.addEventListener('auth-expired', this.expired)
    this.refresh()
  },
  beforeDestroy() {
    window.removeEventListener('auth-expired', this.expired)
  },
  methods: {
    expired() {
      const path = this.$route.fullPath
      clearSession(this.$store)
      if (this.$route.name !== 'login')
        this.$router.replace({ path: '/', query: { redirect: path, expired: '1' } })
    },
    async refresh() {
      if (this.$route.name === 'login') return
      try {
        await employee(this.$store)
        const data = await this.$api.post('/api/employee/remind/count', {})
        this.$store.state.employee.state.remind = data.count || 0
      } catch (e) {
        /* 页面保留自己的重试入口。 */
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/layout.vue